module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_10.68c26b73.gif";